import { z } from 'zod';

export const SupplierSchema = z.object({
  id: z.string().uuid(),
  tenant_id: z.string().uuid(),
  piva: z.string().regex(/^\d{11}$/).nullable(),
  codice_fiscale: z.string().nullable(),
  name: z.string().min(1).max(200),
  category: z
    .enum([
      'ortofrutta',
      'carne',
      'pesce',
      'latticini',
      'bevande',
      'pane',
      'pulizia',
      'altro',
    ])
    .default('altro'),
  address: z.string().nullable(),
  email: z.string().email().nullable(),
  phone: z.string().nullable(),
  iban_encrypted: z.string().nullable(),
  notes: z.string().nullable(),
  auto_created: z.boolean().default(false),
  created_at: z.string().datetime(),
  archived_at: z.string().datetime().nullable(),
  version: z.number().int().nonnegative().default(0),
});
export type Supplier = z.infer<typeof SupplierSchema>;
